import { SectionToggleState, useSectionHelper } from "hooks";
import { FormCollapse } from "components/Form";
import { useFormikContext } from "formik";
import React from "react";
import { Section } from "containers/Settings/RuleBooks/Rules/CustomRules/constants";
import { getOutputFormatOptions } from "./RuleOutputFormatField";
import { PresentationFormattingHeader } from "./PresentationFormattingHeader";
import { PresentationFormattingForm } from "./PresentationFormattingForm";

interface PresentationFormattingSectionProps {
  sectionToggleState: SectionToggleState;
}

export function PresentationFormattingSection(
  props: PresentationFormattingSectionProps,
) {
  const { sectionToggleState } = props;
  const { isOpen, onToggle } = useSectionHelper(
    sectionToggleState,
    Section.PRESENTATION_FORMATTING,
  );

  const { values } = useFormikContext();

  const unitAmountOutputFormatOptions = getOutputFormatOptions(
    values,
    "value.amount.valueType",
    "unit_amount_raw_format",
  );

  const quantityOutputFormatOptions = getOutputFormatOptions(
    values,
    "value.units.valueType",
    "quantity_raw_format",
  );

  const header = <PresentationFormattingHeader />;

  return (
    <FormCollapse
      isOpen={isOpen}
      onToggle={onToggle}
      header={header}
      dataTour={
        isOpen ? "hidePresentationFormatting" : "showPresentationFormatting"
      }
    >
      <PresentationFormattingForm
        unitAmountOutputFormatOptions={unitAmountOutputFormatOptions}
        quantityOutputFormatOptions={quantityOutputFormatOptions}
      />
    </FormCollapse>
  );
}
